import React from 'react';
import HouseOfferCard from './HouseOfferCard';
import { Col } from 'react-bootstrap';

const HouseOffersComponent = ({ offers, width }) => {
  if (!offers) {
    return <></>;
  }

  return (
    <Col md={width}>
      {(offers.length === 0 || !offers?.length) && <h5>Brak dostępnych domków.</h5>}

      {offers.map((offer, index) => (
        <HouseOfferCard key={index} offer={offer} />
      ))}
    </Col>
  );
};

export default HouseOffersComponent;
